import { translate } from '@portal/services/i18n';

export enum EasyCreditLoanStatus {
  OPENED = 1,
  PAYMENT_RECEIVED = 2,
  LOAN_PAYED = 3,
}

export const EasyCreditLoanStatusArray = [
  {
    value: EasyCreditLoanStatus.OPENED,
    name: translate('PAGES.EASY_CREDIT.STATUS.OPENED'),
  },
  {
    value: EasyCreditLoanStatus.PAYMENT_RECEIVED,
    name: translate('PAGES.EASY_CREDIT.STATUS.PAYMENT_RECEIVED'),
  },
  {
    value: EasyCreditLoanStatus.LOAN_PAYED,
    name: translate('PAGES.EASY_CREDIT.STATUS.LOAN_PAYED'),
  },
];

export const getEasyCreditLoanStatus = (id?: number) => {
  return EasyCreditLoanStatusArray.find((archive) => archive.value === id)
    ?.name;
};
